import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TicketsAndGuestsInitialsService{
    public userDataMap: Map<string, { initials: string; color: string }> = new Map();

    private userInitialsColors: string[] = [
        '#33a853', '#ea4336', '#4285f4', 
    ];

    getUsersInitials(name: string){
        if (!name) return "";

        const words = name.trim().split(/\s+/); 

        if (words.length === 2) {
            return words[0][0].toUpperCase() + words[1][0].toUpperCase();
        } 

        return name.substring(0, 1).toUpperCase();
    }

    getRandomColor(): string {
        return this.userInitialsColors[Math.floor(Math.random() * this.userInitialsColors.length)];
    }

    initInitialsMap(data: any) {
        data.forEach(item => {
            if (item.winnerUser?.name && !this.userDataMap.has(item.winnerUser.name)) {
              const initials = this.getUsersInitials(item.winnerUser.name);
              const color = this.getRandomColor();
              this.userDataMap.set(item.winnerUser.name, { initials, color });
            }
          });
    }

}